import { useIntl } from "react-intl";

import moment from "moment/moment";

export const useSeniorityFormat = (startDate: Date) => {
  const intl = useIntl();
  const now = moment(Date.now());
  const date = moment(startDate);

  const translatedYear = intl.formatMessage({
    id: "time.year",
    defaultMessage: "year",
  });

  const translatedMonth = intl.formatMessage({
    id: "time.month",
    defaultMessage: "month",
  });

  const translatedDay = intl.formatMessage({
    id: "time.day",
    defaultMessage: "day",
  });

  const translatedAnd = intl.formatMessage({
    id: "vocab.and",
    defaultMessage: "and",
  });

  const translatedFirstDay = intl.formatMessage({
    id: "time.first_day",
    defaultMessage: "First day!",
  });

  const years = now.diff(date, "years");
  date.add(years, "years");

  const months = now.diff(date, "months");
  date.add(months, "months");

  const days = now.diff(date, "days");

  const yearsFormat = years > 0 ? getDateFormat(years, translatedYear) : "";
  const monthsFormat = months > 0 ? getDateFormat(months, translatedMonth) : "";
  const daysFormat = days > 0 ? getDateFormat(days, translatedDay) : "";

  const firstSeparator = yearsFormat && monthsFormat ? ", " : "";
  const secondSeparator =
    (yearsFormat || monthsFormat) && days ? " " + translatedAnd + " " : "";

  const result = `${yearsFormat}${firstSeparator}${monthsFormat}${secondSeparator}${daysFormat}`;
  return result || translatedFirstDay;
};

const getDateFormat = (n: number, text: string): string => {
  return `${n} ${text}${n > 1 && text !== "mois" ? "s" : ""}`;
};
